import React from 'react';
import { Box, Button, Modal, SpaceBetween } from '@cloudscape-design/components-themed/components';
const InformationModal = (props) => {
    return React.createElement(Modal, { visible: props.visible, onDismiss: props.onDiscard, header: props.header, closeAriaLabel: "Close dialog", footer: React.createElement(Box, { float: "right" },
            React.createElement(SpaceBetween, { direction: "horizontal", size: "xs" },
                React.createElement(Button, { variant: "primary", onClick: props.onDiscard }, props.discardButtonText))) }, props.info);
};
export default InformationModal;
